import React, { useMemo } from 'react';
import { translate } from '../../../Services/translation';
import clsx from 'clsx';
import OrderListItemProps from '../../../Types/OrderListItemProps';

const OrderListItemMobile = ({
  order,
  onClick,
  isB2b,
}: OrderListItemProps) => {
  const deliveryWithTracking = useMemo(
    () => order.deliveries.find((d) => !!d.trackingUrl),
    [order.deliveries]
  );
  const trackingUrl = deliveryWithTracking?.trackingUrl;
  const trackingReference = deliveryWithTracking?.trackingReference;

  return (
    <li
      className={clsx(
        'p-4',
        'border',
        'border-solid',
        'border-gray-200',
        'rounded',
        'flex',
        'flex-col',
        'gap-3'
      )}
    >
      <div className="flex items-center justify-between">
        <p className="text-lg font-bold">
          {translate('orderlist.column.ordernumber')}:{' '}
          {order.externalOrderID}
        </p>
        <button
          onClick={() => onClick && onClick(order)}
          className={clsx(
            'btn',
            'btn--outline',
            'btn--small',
            'col-span-2',
            'font-bold',
            'md:col-span-1',
            'md:mt-0',
            'border-gray-700'
          )}
        >
          {translate('orderlist.column.readmore')}
        </button>
      </div>
      <div
        className={clsx('grid', 'grid-cols-2', 'md:grid-cols-6', 'gap-3')}
      >
        <div className="flex flex-col gap-0.5">
          <p className={clsx('text-sm', 'uppercase', 'text-gray-500')}>
            {translate('orderlist.column.orderdate')}
          </p>
          <p className={clsx('text-md')}>{order.orderDate}</p>
        </div>
        <div className="flex flex-col gap-0.5">
          <p className={clsx('text-sm', 'uppercase', 'text-gray-500')}>
            {translate('orderlist.column.grandtotal')}
          </p>
          <p className={clsx('text-md')}>{order.orderGrandTotal}</p>
        </div>
        {isB2b && (
          <div className="flex flex-col gap-0.5">
            <p className={clsx('text-sm', 'uppercase', 'text-gray-500')}>
              {translate('orderlist.column.b2b-ordernumber')}
            </p>
            <p className={clsx('text-md')}>
              {order.alternateOrderNumber ?? ''}
            </p>
          </div>
        )}
        <div className="flex flex-col gap-0.5">
          <p className={clsx('text-sm', 'uppercase', 'text-gray-500')}>
            {translate('orderlist.column.status')}
          </p>
          <p className={clsx('text-md')}>
            {translate(`order-status.${order.orderStatus.toLowerCase()}`)}
          </p>
        </div>
        <div className="flex flex-col gap-0.5">
          <p className={clsx('text-sm', 'uppercase', 'text-gray-500')}>
            {translate('orderlist.column.tracking')}
          </p>
          <p className={clsx('text-md')}>
            {trackingUrl ? (
              <a
                className={clsx(
                  'underline',
                  !!trackingReference && 'uppercase'
                )}
                href={trackingUrl}
                target="_blank"
                aria-label="Tracking URL"
                rel="noreferrer"
              >
                {trackingReference ?? trackingUrl}
              </a>
            ) : (
              <p>{translate('mypage.order.no-tracking')}</p>
            )}
          </p>
        </div>
      </div>
    </li>
  );
};

export default OrderListItemMobile;
